import { render, staticRenderFns } from "./ToolDieMachineAdd.vue?vue&type=template&id=654bf40c&"
import script from "./ToolDieMachineAdd.vue?vue&type=script&lang=js&"
export * from "./ToolDieMachineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports